module.exports = __webpack_public_path__ + "static/media/threat-dashboard.3e05e402.png";